module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div id=\'activation\'></div>\n<div id=\'details-accordion\'></div>\n<div id=\'location-accordion\'></div>\n<div id=\'tariffs-accordion\'></div>\n<div id=\'attributes-accordion\'></div>\n<div id=\'indicators-accordion\'></div>\n<div id=\'zones-accordion\'></div>\n<div id=\'circuits-accordion\'></div>\n<div id=\'folders-accordion\'></div>\n<div id=\'tenants-accordion\'></div>\n';

}
return __p
}